import { HeartFilled, HeartOutlined } from '@ant-design/icons';

import { Button, useTheme } from '@suntex.fim/ui';

import '../style/ModuleCatalog.scss';

export type FavoriteButtonProps = {
  active: boolean;
} & Pick<
  React.ComponentProps<typeof Button>,
  'aria-label' | 'onClick' | 'size'
>;

export function FavoriteButton({ active, ...props }: FavoriteButtonProps) {
  const { colors } = useTheme();
  return (
    <Button
      intent="icon"
      icon={
        active ? (
          <HeartFilled style={{ color: colors.red }} />
        ) : (
          <HeartOutlined />
        )
      }
      aria-label={active ? 'Remove from favorites' : 'Add to favorites'}
      {...props}
    />
  );
}
